import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseCreateAnnotationMutationVariables = {
  tourId: string;
  type: VirtualTourAnnotationType;
  message?: string;
  cleanMessage?: string;
  metadata?: {
    attachments?: Omit<VirtualTourAnnotationCommentAttachment, 'url'>[];
  };
  position: { x: number; y: number; z: number };
  mentions?: Array<string>;
};

export const useCreateAnnotationMutation = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async (payload: UseCreateAnnotationMutationVariables) => {
      const { data } = await authApi.post(`/virtual-tour/annotation`, payload);
      return data;
    },
    onSuccess: (_, { tourId }) => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-annotations", tourId],
      });
    },
  });

  return result;
};
